
export default {
  name: "FaqAccordion",
  props: {
    // [{ question, answer }]
    items: { type: Array, default: () => [] },
    // Section eyebrow number ("08"); continues the H2 section count.
    number: { type: String, default: "" },
  },
  data() {
    return {
      openIndex: null, // one open at a time; null = all closed
    };
  },
  methods: {
    toggle(i) {
      this.openIndex = this.openIndex === i ? null : i;
    },
  },
};
